export function eventOnMapReducer(state = null, action) {
    switch (action.type) {
        case 'SHOW_EVENT_ON_MAP':
            return action.event;
        case 'CLEAR_EVENT_ON_MAP':
            return null;
        default:
            return state;
    }
}
